import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  canAccessPathForRole,
  getDefaultPathForRole,
} from "../constants/roleAccess";
import type { RootState } from "../redux/store";

const PrivateRoutes: React.FC = () => {
  const location = useLocation();
  const currentRole = useSelector(
    (state: RootState) => state.userRoles?.currentRole,
  );
  const persistedRoleId = sessionStorage.getItem("selectedRoleId");
  const effectiveRole = currentRole || persistedRoleId;

  if (!effectiveRole) {
    return <Outlet />;
  }

  if (!canAccessPathForRole(effectiveRole, location.pathname)) {
    return <Navigate to={getDefaultPathForRole(effectiveRole)} replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;

export const componentsPath = [
  { id: 2, path: "/admin", label: "Admin" },
  { id: 3, path: "/endUserView", label: "End User" },
  { id: 3, path: "/approverView", label: "Approver" },
];

export const appRootUrl = process.env.REACT_APP_ROOT_URL as string | undefined;
